// extracted by mini-css-extract-plugin
export var indeterminate = "_4t-6";
export var md = "_4t-5";
export var semantic = "_4t-7";
export var sm = "_4t-4";
export var text = "_4t-8";
export var toggleControl = "_4t-0";
export var toggleInput = "_4t-1";
export var toggleSwitch = "_4t-2";
export var xs = "_4t-3";